export default {
    // Header Section
    "discover_your": "जानिए अपना",
    "daily_horoscope": "दैनिक राशिफल",
    "daily_cosmic_guidance": "दैनिक ब्रह्मांडीय मार्गदर्शन",
    "daily_horoscope_description": "अपने राशि चिन्ह के अनुसार व्यक्तिगत दैनिक राशिफल प्राप्त करें। प्रेम, करियर, स्वास्थ्य और वित्त पर विशेष जानकारियाँ पाएं, साथ ही दैनिक शुभ अंक, शुभ रंग और ब्रह्मांडीय मार्गदर्शन से अपने दिन को सफल बनाएं।",

    // Service Information
    "enter_details_for_horoscope": "दैनिक राशिफल के लिए अपनी जानकारी भरें",
    "daily_horoscope_subscription": "दैनिक राशिफल सदस्यता",
    "service_price": "सेवा शुल्क",
    "daily_horoscope_subscription_note": "व्यक्तिगत दैनिक राशिफल की मासिक सदस्यता",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_cosmic_influence": "आपका नाम ब्रह्मांडीय ऊर्जा से जुड़ा है, जिससे आपको व्यक्तिगत भविष्यवाणी मिलेगी",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "महिला",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_zodiac_sign": "आपकी राशि और व्यक्तिगत भविष्यवाणी के लिए आवश्यक",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेज़ी",
    "hindi": "हिंदी",
    "telugu": "तेलुगु",
    "kannada": "कन्नड़",
    "language_note": "आपका दैनिक राशिफल चयनित भाषा में भेजा जाएगा",

    // Core Horoscope Features
    "daily_predictions": "दैनिक भविष्यवाणी",
    "love_relationship_insights": "प्रेम और रिश्तों की जानकारी",
    "career_money_guidance": "करियर और धन संबंधी मार्गदर्शन",
    "health_wellness_tips": "स्वास्थ्य और तंदुरुस्ती टिप्स",
    "lucky_numbers_colors": "शुभ अंक और शुभ रंग",
    "monthly_horoscope_bonus": "मासिक राशिफल बोनस",

    "what_you_get": "आपके दैनिक राशिफल में क्या शामिल है",
    "personalized_daily_readings": "व्यक्तिगत दैनिक भविष्यवाणी",
    "love_career_predictions": "प्रेम और करियर की भविष्यवाणी",
    "daily_lucky_elements": "दैनिक शुभ तत्व",
    "monthly_bonus_insights": "मासिक विशेष जानकारियां",

    // Actions & Buttons
    "subscribe_to_horoscope": "दैनिक राशिफल की सदस्यता लें",
    "processing_payment": "भुगतान प्रक्रिया जारी है",
    "processing_request": "सदस्यता सेट की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "horoscope_subscription_processing": "आपकी दैनिक राशिफल सदस्यता सक्रिय हो गई है। आपको हर सुबह आत्मविश्वास के साथ दिन शुरू करने के लिए व्यक्तिगत ब्रह्मांडीय मार्गदर्शन मिलेगा।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "daily_delivery": "दैनिक डिलीवरी",
    "daily_horoscope_delivery_note": "आपका व्यक्तिगत राशिफल हर सुबह भेजा जाएगा",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर दैनिक राशिफल प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "दैनिक राशिफल ईमेल पर भेजा जाएगा",

    // What You'll Receive
    "what_youll_receive": "आपको क्या मिलेगा",
    "daily_horoscope_reading": "व्यक्तिगत दैनिक राशिफल",
    "love_relationship_daily_insights": "प्रेम और रिश्तों की दैनिक जानकारी",
    "career_financial_guidance": "करियर और वित्त संबंधी दैनिक मार्गदर्शन",
    "health_wellness_daily_tips": "स्वास्थ्य और तंदुरुस्ती के दैनिक टिप्स",
    "monthly_special_predictions": "मासिक विशेष भविष्यवाणी",

    // Visual Content
    "sample_daily_horoscope": "नमूना दैनिक राशिफल",
    "leo_horoscope_today": "सिंह राशि का आज का राशिफल",
    "sample_horoscope_reading": "आज व्यक्तिगत विकास और आर्थिक लाभ के अवसर ला सकता है",
    "sample_horoscope_preview": "आपके व्यक्तिगत दैनिक राशिफल की एक झलक, ब्रह्मांडीय अंतर्दृष्टियों के साथ",
    "zodiac_signs": "राशि चिन्ह",

    // Zodiac Sign Names
    "aries": "मेष",
    "taurus": "वृषभ",
    "gemini": "मिथुन",
    "cancer": "कर्क",
    "leo": "सिंह",
    "virgo": "कन्या",
    "libra": "तुला",
    "scorpio": "वृश्चिक",
    "sagittarius": "धनु",
    "capricorn": "मकर",
    "aquarius": "कुंभ",
    "pisces": "मीन",

    // Status & Processing
    "your_horoscope_status": "आपकी राशिफल सदस्यता की स्थिति",
    "processing_your_subscription": "आपकी सदस्यता सक्रिय की जा रही है",
    "subscription_processing_message": "आपकी दैनिक राशिफल सदस्यता सक्रिय हो रही है। आपको कल सुबह से व्यक्तिगत ब्रह्मांडीय मार्गदर्शन मिलने लगेगा।",
    "subscription_id": "सदस्यता आईडी",
    "status": "स्थिति",
    "processing": "सक्रिय हो रहा है",
    "active": "सक्रिय",
    "confirmation_email_sent": "पुष्टिकरण ईमेल भेजा गया",
    "daily_whatsapp_updates": "दैनिक व्हाट्सऐप अपडेट सक्रिय",
    "first_horoscope_tomorrow": "पहला राशिफल कल सुबह मिलेगा",

    // Support & Contact
    "contact_support": "राशिफल सहायता से संपर्क करें",
    "need_help": "मदद चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जानकारी भरें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "subscription_failed": "सदस्यता सक्रिय नहीं हो पाई। कृपया सहायता टीम से संपर्क करें।",

    // Daily Horoscope Categories
    "general_forecast": "सामान्य भविष्यवाणी",
    "love_romance": "प्रेम और रोमांस",
    "career_profession": "करियर और पेशा",
    "health_wellbeing": "स्वास्थ्य और कल्याण",
    "finance_money": "वित्त और धन",
    "family_relationships": "परिवार और रिश्ते",
    "travel_adventure": "यात्रा और रोमांच",
    "spiritual_growth": "आध्यात्मिक विकास",

    // Lucky Elements
    "lucky_number": "शुभ अंक",
    "lucky_color": "शुभ रंग",
    "lucky_time": "शुभ समय",
    "lucky_direction": "शुभ दिशा",
    "lucky_gemstone": "शुभ रत्न",
    "avoid_color": "बचने योग्य रंग",
    "avoid_time": "बचने का समय",

    // Daily Ratings
    "love_rating": "प्रेम रेटिंग",
    "career_rating": "करियर रेटिंग",
    "health_rating": "स्वास्थ्य रेटिंग",
    "finance_rating": "वित्त रेटिंग",
    "overall_rating": "कुल दिन का मूल्यांकन",

    // Planetary Influences
    "planetary_influence": "ग्रहों का प्रभाव",
    "moon_phase": "चंद्र चरण",
    "ruling_planet": "आज का स्वामी ग्रह",
    "planetary_transit": "मुख्य ग्रह गोचर",
    "retrograde_alert": "वक्री ग्रह चेतावनी",

    // Relationship Insights
    "single_horoscope": "अविवाहित प्रेम पूर्वानुमान",
    "relationship_horoscope": "रिश्ते का पूर्वानुमान",
    "marriage_horoscope": "विवाह पूर्वानुमान",
    "friendship_forecast": "मित्रता पूर्वानुमान",
    "family_harmony": "परिवार में सामंजस्य",

    // Career Guidance
    "job_prospects": "नौकरी के अवसर",
    "business_forecast": "व्यवसाय पूर्वानुमान",
    "investment_advice": "निवेश सलाह",
    "career_decisions": "करियर निर्णय",
    "workplace_relationships": "कार्यस्थल संबंध",

    // Health Tips
    "physical_health": "शारीरिक स्वास्थ्य",
    "mental_wellbeing": "मानसिक स्वास्थ्य",
    "exercise_recommendation": "व्यायाम की सलाह",
    "diet_suggestion": "आहार सुझाव",
    "stress_management": "तनाव प्रबंधन",

    // Weekly & Monthly
    "weekly_overview": "साप्ताहिक अवलोकन",
    "monthly_highlights": "मासिक मुख्य बिंदु",
    "seasonal_forecast": "मौसमी पूर्वानुमान",
    "year_ahead": "आगामी वर्ष का पूर्वावलोकन",

    // Compatibility
    "compatible_signs_today": "आज के अनुकूल राशि",
    "challenging_signs": "चुनौतीपूर्ण राशि",
    "best_match_today": "आज का सर्वश्रेष्ठ मेल",
    "avoid_conflicts_with": "इनसे टकराव से बचें",

    // Remedies & Tips
    "daily_remedy": "दैनिक उपाय",
    "positive_affirmation": "सकारात्मक पुष्टि",
    "meditation_tip": "ध्यान टिप",
    "crystal_recommendation": "क्रिस्टल की सलाह",
    "mantra_for_today": "आज का मंत्र",

    // Special Occasions
    "birthday_special": "जन्मदिन विशेष पूर्वानुमान",
    "new_moon_influence": "अमावस्या का प्रभाव",
    "full_moon_impact": "पूर्णिमा का प्रभाव",
    "eclipse_effects": "ग्रहण का प्रभाव",
    "festival_predictions": "त्योहार की भविष्यवाणी",

    // Subscription Management
    "subscription_active": "सदस्यता सक्रिय",
    "next_billing": "अगली बिलिंग तिथि",
    "cancel_subscription": "सदस्यता रद्द करें",
    "modify_subscription": "सदस्यता बदलें",
    "subscription_history": "सदस्यता इतिहास",

    // Personalization
    "customize_preferences": "पसंद को अनुकूलित करें",
    "delivery_time": "पसंदीदा डिलीवरी समय",
    "content_focus": "सामग्री के मुख्य क्षेत्र",
    "notification_settings": "सूचना सेटिंग्स",

    // Premium Features
    "premium_insights": "प्रीमियम जानकारियां",
    "detailed_analysis": "विस्तृत विश्लेषण",
    "astrologer_notes": "ज्योतिषी की व्यक्तिगत टिप्पणियां",
    "priority_support": "प्राथमिकता ग्राहक सहायता"
};
